import { networkClient } from '@network/networkClient'
import { getGlobalParams } from '../globalParams'
import { FETCH_FREEBETS, GET_FREEBETS_COUNT_ON_STATUS } from '../queries/freebetQueries'
import { logger } from '@logger'

const MODULE = 'Freebet Service'

// Player's freebets, optionally filtered by status. Globals from session; the
// component passes only { status, page, pageSize }. Page info echoed for the mapper.
export const fetchFreebets = async ({ status, page = 1, pageSize = 10 } = {}) => {
  const { playerId, operatorId, brandId, gameCode } = getGlobalParams()

  const response = await networkClient({
    request: {
      query: FETCH_FREEBETS,
      variables: { playerId, operatorId, brandId, status, size: pageSize, page, gameCode },
    },
  })

  logger.info(MODULE, 'fetchFreebets Response', response)

  if (response.players.fetchFreebets.success) {
    return { ...response.players.fetchFreebets.data, page, pageSize }
  } else {
    throw new Error(response.players.fetchFreebets.message || 'Failed to fetch freebets')
  }
}

// Count of freebets grouped by status.
export const getFreebetsCountOnStatus = async ({ status } = {}) => {
  const { playerId, operatorId, brandId, gameCode } = getGlobalParams()

  const response = await networkClient({
    request: {
      query: GET_FREEBETS_COUNT_ON_STATUS,
      variables: { playerId, operatorId, brandId, status, gameCode },
    },
  })

  logger.info(MODULE, 'getFreebetsCountOnStatus Response', response)

  if (response.players.getFreebetsCountOnStatus.success) {
    return response.players.getFreebetsCountOnStatus.data
  } else {
    throw new Error(
      response.players.getFreebetsCountOnStatus.message || 'Failed to fetch freebets count'
    )
  }
}
